import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { UpdateWfdPriorityDto, WfdPriorityLookup, WfdPriorityLevel } from '../models/wfd-priority.model';

@Injectable({
    providedIn: 'root'
})
export class WfdCandidateFacilityService {
    private readonly _coreApiPath: string;
    private readonly _wfdApiPath: string;

    constructor(
        private readonly _httpClient: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this._coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
        this._wfdApiPath = combine(this._coreApiPath, 'workforce-disruption/candidate-facility/WFDPriorities');
    }

    getWfdPriorities(): Observable<WfdPriorityLookup[]> {
        const url = `${this._wfdApiPath}/lookups`;
        return this._httpClient.get<WfdPriorityLookup[]>(url);
    }

    getCandidateWfdPriority(candidateId: number, facilityId: number): Observable<WfdPriorityLevel> {
        const url = `${this._wfdApiPath}/${candidateId}/${facilityId}`;
        return this._httpClient.get<WfdPriorityLevel>(url);
    }

    isWfdReturner(candidateId: number): Observable<boolean> {
        const url = `${this._wfdApiPath}/${candidateId}/is-returner`;
        return this._httpClient.get<boolean>(url);
    }

    bulkUpdateWfdPriorities(payload: UpdateWfdPriorityDto): Observable<void> {
        return this._httpClient.put<void>(this._wfdApiPath, payload);
    }
}
